import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { InfoCircleIcon } from "@gemini/icons";
import { Button, Modal } from "@gemini/ui";
import { useI18n } from "@/contexts/i18n";
const Trigger = ({ ...rest }) => {
    const { t } = useI18n();
    return (_jsx(Button, { iconOnly: true, icon: InfoCircleIcon, variant: "tertiary", size: "40", ...rest, children: t("provider.badge.modal.cta") }));
};
export const PartnerBadgesModal = ({ badges, customTrigger, }) => {
    const { t } = useI18n();
    const TriggerComponent = customTrigger || Trigger;
    return (_jsx(Modal, { title: t("provider.badge.modal.title"), isDismissable: true, trigger: TriggerComponent, children: _jsx(Box, { display: "flex", flexDirection: "column", gap: "spacing.40", children: badges === null || badges === void 0 ? void 0 : badges.map((badge) => {
                return (_jsxs(Box, { display: "flex", gap: "spacing.16", children: [_jsx(Box, { as: "img", alt: "partner badge", src: badge.imageUrl, width: "sizing.56", height: "sizing.56", borderRadius: "radius.8" }), _jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: [_jsx(Box, { typography: "typography.body.16.bold", children: badge.title }), _jsx(Box, { children: badge.description })] })] }, badge.title));
            }) }) }));
};
